import React, { Component} from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';

import Form from '../blocks/form-blocks/Form';
import FLNames from '../blocks/form-blocks/FLNames';
import Contacts from '../blocks/form-blocks/Contacts';
import Education from '../blocks/form-blocks/Education';
import Checkbox from '../blocks/checkbox/Checkbox';
import FormBlock from '../blocks/form-blocks/FormBlock';
import Job from '../blocks/form-blocks/Job';
import FormSubmit from '../blocks/form-blocks/FormSubmit';
import { downloadSchoolList, downloadInstituteList, formSubmit } from '../actions/auth-action';
import { saveUserChanges, clearAllMessages } from '../actions/participant-action';
import { emailHandler, notEmptyHandler, phoneHandler, newPasswordHandler } from '../validators/form-validators';
import UserSections from '../blocks/user-sections/UserSections';
import { clearFields } from '../actions/field-action';
import './style.css';


class UserProfile extends Component {

  state = {
    isWorks: false
  };

  onCheckChange() {
    this.setState({isWorks: !this.state.isWorks});
  }

  componentWillUnmount() {
    this.props.clearAllMessages();
    this.props.clearFields();
  }

  componentWillMount() {
    if (!this.props.participantView.userShortView || !this.props.withServer) {
      browserHistory.push('/');
    }
    window.scrollTo(0, 0);
    this.setState({
      isWorks: this.props.participantView.jobProfileView != null,
      grade: this.props.participantView.schoolProfileView ? this.props.participantView.schoolProfileView.grade : null,
      course: this.props.participantView.studentProfileView ? this.props.participantView.studentProfileView.course : null,
    });

    if (this.props.schoolList.length === 0) {
      this.props.downloadSchoolList();
      this.props.downloadInstituteList();
    }
  }

  beforeFormSubmit() {
    this.props.formSubmit();
  }

  afterValidation() {
    if (this.props.isValidated) {
      let data = {...this.props.fields};
      data['cityId'] = 1;
      if (data.password === '') {
        delete data.password;
      }
      if (this.state.grade) {
        data['grade'] = this.state.grade;
      }
      if (this.state.course) {
        data['course'] = this.state.course;
      }
      let form = new FormData();
      Object.keys(data).forEach(field => {
        form.append(field, data[field])
      });
      this.props.saveUserChanges(form);
    }
  }

  courseHandler(course) {
    this.setState({course: course});
  }

  gradeHandler(grade) {
    this.setState({grade: grade});
  }

  render() {

    if (!this.props.participantView.userShortView || !this.props.withServer) {
      browserHistory.push('/');
    }

    if (this.props.afterValidate) {
      this.afterValidation();
    }

    let workBlock = null;
    if (this.state.isWorks) {
      workBlock = (
        <Job
          defaultCompanyName={this.props.participantView.jobProfileView ? this.props.participantView.jobProfileView.companyName : ''}
          defaultJobPosition={this.props.participantView.jobProfileView ? this.props.participantView.jobProfileView.jobPosition : ''}
          jobHandler={notEmptyHandler}
          positionHandler={notEmptyHandler}
        />
      );
    }

    let profileForm = [];
    let educationSection = null;
    if (this.props.participantView.userShortView) {
      if (this.props.participantView.schoolProfileView) {
        educationSection = (
          <Education
            schoolList={this.props.schoolList}
            instituteList={this.props.instituteList}
            gradeHandler={this.gradeHandler.bind(this)}
            departmentHandler={notEmptyHandler}
            courseHandler={this.courseHandler.bind(this)}
            key='education'
            schoolId={this.props.participantView.schoolProfileView.schoolView.id}
            grade={this.props.participantView.schoolProfileView.grade}
          />
        );
      } else if (this.props.participantView.studentProfileView) {
        educationSection = (
          <Education
            schoolList={this.props.schoolList}
            instituteList={this.props.instituteList}
            gradeHandler={this.gradeHandler.bind(this)}
            departmentHandler={notEmptyHandler}
            courseHandler={this.courseHandler.bind(this)}
            key='education'
            instituteId={this.props.participantView.studentProfileView.instituteView.id}
            department={this.props.participantView.studentProfileView.department}
            course={this.props.participantView.studentProfileView.course}
          />
        );
      }
      const submitBlock = educationSection ?
        <FormSubmit
          key='submit'
          onClick={(e) => {
            e.preventDefault();
            this.beforeFormSubmit();
          }}
        >
          сохранить
        </FormSubmit> : null;
      profileForm = [
        <FLNames
          firstName={this.props.participantView.userShortView.firstName}
          lastName={this.props.participantView.userShortView.lastName}
          firstNameHandler={notEmptyHandler}
          lastNameHandler={notEmptyHandler}
          key='names'
        />,
        <Contacts
          defaultEmailValue={this.props.user.email}
          defaultPhoneValue={this.props.user.phoneNumber}
          emailHandler={emailHandler}
          passwordHandler={newPasswordHandler}
          phoneHandler={phoneHandler}
          key='contact'
          newPass={true}
          ref='contacts'
        />,
        educationSection,
        <FormBlock key='block'>
          <Checkbox
            onChangeCallback={this.onCheckChange.bind(this)}
            name='isWorks'
            inputId='works'
            title='я работаю'
            checked={this.state.isWorks}
          />
          {workBlock}
        </FormBlock>,
        submitBlock
      ];
    }
    const speakerMessage = educationSection ? null : <div className='profile__speaker-message'>Для изменения своих данных обратитись к организаторам</div>;
    return (
      <div className='profile'>
        <div className='profile__title'>личный кабинет</div>
        <UserSections
          sectionsStyleClasses={['profile__user-sections']}
          sectionStyleClasses={['profile__user-sections-element']}
        />
        <Form
          ref='form'
          successMessage={this.props.successUserChangingMessage}
        >
          {speakerMessage}
          <input hidden='hidden' name='cityId' value={1} onChange={() => (null)}/>
          {profileForm}
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.participant.userView,
  allSections: state.participant.allSections,
  schoolList: state.auth.schoolList,
  instituteList: state.auth.instituteList,
  isValidated: state.auth.isValidated,
  afterValidate: state.auth.afterValidate,
  participantView: state.participant.participantView,
  successUserChangingMessage: state.participant.successUserChangingMessage,
  fields: state.fields,
  withServer: state.participant.withServer,
  registrationClosed: state.participant.registrationClosed
});

const mapDispatchToProps = (dispatch) => ({
  downloadInstituteList: bindActionCreators(downloadInstituteList, dispatch),
  downloadSchoolList: bindActionCreators(downloadSchoolList, dispatch),
  formSubmit: bindActionCreators(formSubmit, dispatch),
  saveUserChanges: bindActionCreators(saveUserChanges, dispatch),
  clearAllMessages: bindActionCreators(clearAllMessages, dispatch),
  clearFields: bindActionCreators(clearFields, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(UserProfile);



// WEBPACK FOOTER //
// ./src/user-profile-page/UserProfile.js